var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form"},[_c('v-row'),_c('v-divider',{staticClass:"my-5"}),_c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('v-text-field',{ref:"name",attrs:{"label":_vm.$t('user-groups.name'),"loading":_vm.resourceLoading,"rules":_vm.resourceLoading
            ? []
            : [
                _vm.ownRules.requiredIfGivenNameAndFamilyNameIsEmpty,
                _vm.backEndValidation('name')
              ]},model:{value:(_vm.userGroup.name),callback:function ($$v) {_vm.$set(_vm.userGroup, "name", $$v)},expression:"userGroup.name"}})],1)],1),_c('v-divider',{staticClass:"my-5"}),_c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('v-textarea',{attrs:{"label":_vm.$t('user-groups.notices'),"loading":_vm.resourceLoading,"rules":_vm.resourceLoading ? [] : [_vm.backEndValidation('notices')]},model:{value:(_vm.userGroup.notices),callback:function ($$v) {_vm.$set(_vm.userGroup, "notices", $$v)},expression:"userGroup.notices"}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('ButtonWithMenu',{attrs:{"loading":_vm.loading,"menu-hide":_vm.button_title !== 'create',"general-button":{
          icon: _vm.$props.button_icon,
          text: ("buttons." + (_vm.$props.button_title)),
          eventFunction: _vm.save
        },"menu-items":[
          {
            icon: _vm.$props.button_icon,
            text: "buttons.create-and-new",
            eventFunction: _vm.saveAndNew
          },
          {
            icon: _vm.$props.button_icon,
            text: "buttons.create-and-clone",
            eventFunction: _vm.saveAndClone
          }
        ]}}),(_vm.button_title !== 'create')?[_c('v-btn',{staticClass:"ml-4",attrs:{"color":"primary","to":{
            name: 'NewUserGroup',
            query: {
              userGroup: _vm.userGroup.id
            }
          },"loading":_vm.loading}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v("\n          "+_vm._s(_vm.$t("buttons.clone"))+"\n        ")],1)]:_vm._e()],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }